import type { TaskSummary } from "../api.js";
import { formatBusinessDateTime, taskFailurePresentation } from "../task-presentation.js";
import { TaskStatus } from "./TaskStatus.js";

export function TaskCard({ task }: { task: TaskSummary }) {
  const failure =
    task.status === "FAILED" ? taskFailurePresentation(task.lastErrorCode) : null;
  return (
    <a className="task-card" href={"/tasks/" + task.taskId}>
      <div>
        <strong>{task.displayTitle ?? task.taskId}</strong>
        <span>
          提交人 · {task.submitterDisplayName}
          {task.createdAt ? " · " + formatBusinessDateTime(task.createdAt) : ""}
        </span>
        {failure ? (
          <em>
            {failure.summary}，{failure.nextStep}
          </em>
        ) : null}
      </div>
      <TaskStatus status={task.status} />
    </a>
  );
}
